import { ModelResource } from './resource';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ApPortal, Partner } from '../models';
import type { ListResponse } from '@api/types';
import { QueryParams } from '../query';

export class ApPortals extends ModelResource<ApPortal> {
  model = ApPortal;

  resourcePath = 'v1/ap-portals';

  createPortal(data) {
    return this.api.post(this.path(), { data }).then((response) => response.data);
  }

  updatePortal(portal, request_data) {
    const data = { ...request_data };

    delete data.partner_id;

    return this.api.post(this.path(portal?.id), { data }).then((response) => response.data);
  }

  runReportDownloads(portal) {
    return this.api
      .post(this.path(portal?.id, 'run-report-download'))
      .then((response) => response.data);
  }

  pausePortal(portal) {
    return this.api.post(this.path(portal?.id, 'pause')).then((response) => response.data);
  }

  resumePortal(portal) {
    return this.api.post(this.path(portal?.id, 'resume')).then((response) => response.data);
  }
}
